import "../componentcss/Welcome.css"
function Welcome() {
    return (
        <>
        <div id ="welcome-wrap">
            <div id="background">
                <div id="aLayer">

                </div>
            </div>
            <p>TODO</p>;  
        </div>
        
        </>
    );
}

export default Welcome;